<!--
 * @Description:
 * @Date: 2021-08-18 15:53:32
-->
<template>
  <el-button
    type="primary"
    @click="submit"
    :loading="loading"
    :disabled="loading || disabled"
  >
    {{ needVerify ? '提交审核并进入下一个项目' : '进入下一个项目' }}
  </el-button>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { projectV2 } from '@/api/ajax';
import { getStorage } from '@/tools/storage';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    },
    submitFn: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      type: state => state.homeProject.type,
      projectType: state => state.homeProject.projectType
    }),
    needVerify() {
      //   projectStatus //项目状态  0 乙方待编辑  1  乙方编辑完成   2 甲方待确认   3 甲方编辑完成
      //   auditStatus //审核状态  0 未提交审核  1 审核中  2 审核未通过  3  审核通过
      const { auditStatus, projectStatus } = this.info;
      if (projectStatus <= 1 && ![1, 3].includes(+auditStatus)) {
        // 项目处理待编辑或者乙方编辑完成状态
        // 并且 不是提交审核中
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['syncProjectInfo']),
    async submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // 验证表单有无错误
      try {
        await this.$parent.validate();
      } catch (err) {
        this.loading = false;
        console.error(err);
        return;
      }
      // 获取有无图片题
      const {
        data: {
          data: {
            tXcxProject: { isThereAPicture }
          }
        }
      } = await projectV2.loadProjectV2({
        id: this.projectId,
        projectType: this.projectType
      });

      // 如果是 调研问卷 或 可配置 && 有上传图片题 && 图片查重没开启
      if (
        typeof this.submitFn === 'function' &&
        +isThereAPicture === 1 &&
        +this.$parent.model.isCPicRepeat === 0
      ) {
        try {
          await this.$confirm(
            '该项目问卷编辑中存在图片题，是否开启配置“C端图片查重”功能',
            '提示',
            {
              confirmButtonText: '开启',
              cancelButtonText: '跳过',
              type: 'warning'
            }
          );
          // 开启图片查重
          this.$parent.model.isCPicRepeat = 1;
          this.$message({
            type: 'success',
            message: '已开启图片查重',
            duration: 300
          });
        } catch (e) {
          this.$message({
            type: 'info',
            message: '未开启图片查重',
            duration: 1000
          });
        }
      }

      if (this.needVerify && typeof this.submitFn === 'function') {
        try {
          await this.submitFn(this.type, true);
        } catch (error) {
          this.loading = false;
          return;
        }
      }

      const {
        data: { data }
      } = await projectV2.projectV2ListForEdit({
        currentProjectId: this.projectId,
        ...(getStorage('home-search-query') || {})
      });
      if (!data || data.id == this.projectId) {
        this.$alert('本项目是本次撮合的最后一个项目');
        this.loading = false;
        return;
      }
      if (data) {
        // 项目主要参数
        this.syncProjectInfo(data).then(() => {
          this.$router.replace({
            name: this.$route.name == 'edit' ? 'edit-next' : 'edit',
            query: { id: data.id, projectType: data.projectType }
          });
        });
      }

      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped></style>
